module.exports = __webpack_public_path__ + "static/media/multiple-actions-ui-svgrepo-com.0bbf706c.svg";